<nav class="navbar">
    <div class="container-fluid">
        <div class="navbar-header">
            <div class="navbar-left navbar-logo-container">
                <div class="navbar-logo-container-inner">
                    <a routerLink="/home">
                        <img
                            class="navbar-logo"
                            src="{{ config.app.assets.logoMedium }}"
                            alt="{{ config.plataforma.info.companyName }}"
                        />
                    </a>
                </div>
            </div>
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".user-menu">
                <span class="sr-only">Toggle navigation</span>
                <fa [name]="'cog'" class="icon-toggle"></fa>
            </button>
        </div>
        <div *ngIf="isLoggedIn()" class="clearfix user-menu collapse">
            <ul class="nav navbar-top-links navbar-right">
                <li>
                    <a routerLink="/home" role="button">
                        <span class="centered-icons">
                            <ogr-icon name="home-o"></ogr-icon>
                        </span>
                    </a>
                </li>
                <!--<li>
                    <a routerLink="/notificaciones" class="alerta-container">
                        <span class="centered-icons">
                            <ogr-icon name="megafono-o"></ogr-icon>
                        </span>
                        <alerta-notificaciones class="alerta"></alerta-notificaciones>
                    </a>
                </li>-->
                <li>
                    <span notificaciones-on-navbar class="icon-btn">
                        <span class="centered-icons alerta-container">
                            <ogr-icon name="campana-o"></ogr-icon>
                            <alerta-notificaciones class="alerta"></alerta-notificaciones>
                        </span>
                    </span>
                </li>
                <li>
                    <a (click)="goToAyuda()">Ayuda</a>
                </li>
                <li class="li-username">
                    <a (click)="goToProfile()">
                        <span>{{ usuario_nombre | easyplaceholder: "Usuario" }}</span>
                        <span
                            *ngIf="nivel"
                            class="nivel"
                            [attr.title]="ptosToNextLvl + ' ptos para el siguiente nivel'"
                        >
                            {{ nivel }}
                        </span>
                    </a>
                </li>
                <li class="dropdown last-list-item">
                    <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                        <div class="clearfix last-item-cont">
                            <div class="user-circle-container pull-left">
                                <img *ngIf="usuario_avatar" class="avatar" [src]="usuario_avatar | trustedurl" />
                                <fa *ngIf="!usuario_avatar" class="fa-placeholder" [name]="'user'"></fa>
                                <nivel-circlebar (onReady)="setNivel($event)"></nivel-circlebar>
                            </div>
                            <div class="pull-right little-arrow-user">
                                <fa [name]="'sort-desc'"></fa>
                            </div>
                        </div>
                    </a>
                    <ul class="dropdown-menu dropdown-user">
                        <li>
                            <a (click)="edit()">Editar cuenta</a>
                        </li>
                        <li>
                            <a (click)="logout()">Cerrar sesión</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>
<alerta-box></alerta-box>
